import { gql } from '@apollo/client';

import { useLazyQuery } from 'api';
import permissions from 'api/Apollo/permissions';

export const PIPELINES_METADATA_BY_CLUSTER_QUERY = 'PipelinesMetaDataByCluster';

export const GET_PIPELINES_METADATA_BY_CLUSTER = gql`
  query ${PIPELINES_METADATA_BY_CLUSTER_QUERY}($clusterId: uuid!) {
    pipelines(where: { clusterId: { _eq: $clusterId } }) {
      id
      name
      writekey
    }
  }
`;

export default function useLazyQuerySimplePipelinesByCluster(options = {}) {
  const [executeQuery, { data, isAllowed, loading, error, ...rest }] = useLazyQuery(GET_PIPELINES_METADATA_BY_CLUSTER, {
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'cache-and-network',
    context: { permission: permissions.readPipeline },
    ...options,
  });

  const getPipelineMetaDataByCluster = clusterId => {
    const variables = { clusterId };
    return executeQuery({ variables });
  };

  return [
    getPipelineMetaDataByCluster,
    {
      pipelines: data?.pipelines ?? [],
      loading,
      isAllowed,
      error,
      ...rest,
    },
  ];
}
